/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4c1fa15f&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=4c1fa15f&lang=less"

import exportComponent from "E:\\202601_code\\official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1fa15f"]])

export default __exports__